import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromSelector from './panel.selectors';
import * as fromActions from './panel.actions';
import * as fromReducer from './panel.reducer';
import { IPanelAnalyticsPayload } from '@boxx/panel-core';

@Injectable()
export class PanelStore {
  constructor(private store: Store<fromReducer.PanelState>) {}

  getAnalytics(filter?: IPanelAnalyticsPayload) {
    this.store.dispatch(fromActions.getAnalyticsBeginAction({ filter }));
  }

  get analyticsData$() {
    return this.store.select(fromSelector.getAnalyticsData);
  }
  get analyticsLoading$() {
    return this.store.select(fromSelector.getAnalyticsLoading);
  }
  get analyticsSuccess$() {
    return this.store.select(fromSelector.getAnalyticsSuccess);
  }
  get analyticsError$() {
    return this.store.select(fromSelector.getAnalyticsError);
  }
  get analyticsFetched$() {
    return this.store.select(fromSelector.getAnalyticsFetched);
  }


  getEcwidData() {
    this.store.dispatch(fromActions.getEcwidDataStatusBeginAction());
  }

  get ecwidStadisticsData$() {
    return this.store.select(fromSelector.getEcwidStadisticsData);
  }
  get ecwidStadisticsLoading$() {
    return this.store.select(fromSelector.getEcwidStadisticsLoading);
  }
  get ecwidStadisticsSuccess$() {
    return this.store.select(fromSelector.getEcwidStadisticsSuccess);
  }
  get ecwidStadisticsError$() {
    return this.store.select(fromSelector.getEcwidStadisticsError);
  }
  get ecwidStadisticsFetched$() {
    return this.store.select(fromSelector.getEcwidStadisticsFetched);
  }

}
